import React from 'react'

import './style.css'
import { Container } from './Container'
import { Title } from './Title'

export type ContainerProps = {
  children: React.ReactNode
  footer?: React.ReactNode
  style?: React.CSSProperties
}

export type TitleProps = {
  children: React.ReactNode
  className?: string
}

export const Main = {
  Container,
  Title,
}
